import { QDialog, QInput, QMenu, QSelect } from 'quasar'
import I18nDateInput from 'ui-common/base/components/i18nDateInput.vue'
import ariaInvalid from '@wilken8/portal-ui-common/directives/ariaInvalid.js'
import itemAutoRole from '@wilken8/portal-ui-common/directives/itemAutoRole.js'
import QItemStandalone from '@wilken8/portal-ui-common/components/overrides/QItemStandalone.js'

const setDefault = (component, key, value) => {
  const prop = component.props[key]
  switch (typeof prop) {
    case 'object':
      prop.default = value
      break
    case 'function':
      component.props[key] = {
        type: prop,
        default: value
      }
      break
    case 'undefined':
      throw new Error('unknown prop: ' + key)
    default:
      throw new Error('unhandled type: ' + typeof prop)
  }
}

const apply = (obj) => {
  Object.values(obj ?? {})
    .forEach((defaultInfo) => {
      Object.entries(defaultInfo.props ?? []).forEach(([propKey, value]) => {
        setDefault(defaultInfo.component, propKey, value)
      })
    })
}

export const defaultProps = {
  [QInput.name]: {
    component: QInput,
    props: {
      outlined: () => true,
      // labelColor: () => 'dark',
      debounce: () => 300
    }
  },
  [QSelect.name]: {
    component: QSelect,
    props: {
      outlined: () => true
      // labelColor: () => 'dark'
    }
  },
  [I18nDateInput.name]: {
    component: I18nDateInput,
    props: {
      outlined: () => true
      // labelColor: () => 'dark'
    }
  },
  [QMenu.name]: {
    component: QMenu,
    props: {
      noRefocus: () => true
    }
  },
  [QDialog.name]: {
    component: QDialog,
    props: {
      noRefocus: () => false
    }
  }
}

export default (customDefaults, app) => {
  apply(defaultProps)
  if (customDefaults) {
    apply(customDefaults)
  }

  if (app) {
    app.component(QItemStandalone.name, QItemStandalone)
    app.directive('aria-invalid', ariaInvalid)
    app.directive('item-auto-role', itemAutoRole)
  }
}
